import React from "react";
import {Button, Col, Row} from "react-bootstrap";
export default function DocumentSelector({
                                             selectedDocument,
                                             setSelectedDocument
                                         }) {
    const documents = [
        {
            id: "aadhaar",
            name: "Aadhaar Card",
            icon: "🪪"
        },
        {
            id: "pan",
            name: "PAN Card",
            icon: "💳"
        },
        {
            id: "passport",
            name: "Passport",
            icon: "📘"
        },
        {
            id: "license",
            name: "Driving License",
            icon: "🚗"
        },
        {
            id: "voter",
            name: "Voter ID",
            icon: "🗳️"
        }
    ];
    return (
        <>

            <h6>
                Select Identity Document
            </h6>


            <Row className="g-2">


                {
                    documents.map(doc => (
                        <Col
                            xs={6}
                            md={4}
                            key={doc.id}
                        >

                            <Button

                                className="w-100"

                                variant={
                                    selectedDocument === doc.id
                                        ?
                                        "primary"
                                        :
                                        "outline-primary"
                                }


                                onClick={() => {
                                    setSelectedDocument(doc.id)
                                }}

                            >

                                {doc.icon}

                                <br/>

                                {doc.name}


                            </Button>


                        </Col>
                    ))
                }


            </Row>


        </>
    );
}